// src/components/ModalsContainer/EditDisplayNameModal.js
import React from 'react';
import PropTypes from 'prop-types';
import './EditDisplayNameModal.css';

/**
 * Modal for editing device display name
 * Provides inline editing with validation and save/cancel actions
 */
const EditDisplayNameModal = ({
  isOpen,
  value,
  currentName,
  isSaving,
  onChange,
  onKeyDown,
  onCancel,
  onSave,
}) => {
  if (!isOpen) return null;

  const isSaveDisabled =
    isSaving ||
    value.trim().length === 0 ||
    value.trim() === currentName;

  return (
    <div className="edit-modal-overlay">
      <div className="edit-modal-dialog">
        <h2>Edit Display Name</h2>
        <label htmlFor="displayNameInput">New Display Name:</label>
        <input
          id="displayNameInput"
          type="text"
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          maxLength={50}
          disabled={isSaving}
          autoFocus
        />
        <div className="edit-modal-actions">
          <button
            className="edit-modal-button cancel"
            onClick={onCancel}
            disabled={isSaving}
          >
            Cancel
          </button>
          <button
            className="edit-modal-button save"
            onClick={onSave}
            disabled={isSaveDisabled}
          >
            Save
            {isSaving && <span className="save-spinner"></span>}
          </button>
        </div>
      </div>
    </div>
  );
};

EditDisplayNameModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  currentName: PropTypes.string,
  isSaving: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default EditDisplayNameModal;
